import React  from 'react';
import {FieldViewSmallProps} from "../../../../render/view-small";

export default function FieldTaskSystemStatus_ViewSmall(props:FieldViewSmallProps) {

    const value = _.get(props.model, props.field.fieldId, null)

    const systemStatusColor = gd.const.systemStatusColor[value]
    const systemStatusName = gd.const.systemStatusList[value]

    return (
        <div className={Classes('ui5-status-list', 'status-c{0}'.f(systemStatusColor), props.className)}>
            {systemStatusName}
        </div>
    );

}
